const AttributeNames = {
  HONO_TYPE: 'hono.type',
  HONO_NAME: 'hono.name',
} ;

const HonoTypes = {
  MIDDLEWARE: 'middleware',
  REQUEST_HANDLER: 'request_handler',
} ;

export { AttributeNames, HonoTypes };
//# sourceMappingURL=constants.js.map
